const LOW = 0.5;
const MEDIUM = 1;
const HIGH = 3;

export const SLIPPAGES = [LOW, MEDIUM, HIGH];

export const DEFAULT_SLIPPAGE = 1;

export const HIGH_SLIPPAGE = 5;

export const MAX_SLIPPAGE = 30;

export const MIN_SLIPPAGE = 0;
